import styled from "styled-components";
import color from "../../assets/css/colors";

export const Container = styled.div`
    background: ${color.white};

    .button {
        z-index: 10;
        position: fixed;
        right: 15px;
        bottom: 15px;
        width: auto;
        background: ${color.white};
        border-radius: 50%;
        padding: 3px 10px;
        color: ${color.primary};
        display: flex;
        align-items: center;
        transition: .2s;
        box-shadow: 0 0 0 5px rgb(245 139 30 / 30%);

        @media (max-width: 500px){
            right: 15px;
            bottom: 80px;
        }
    }

    .icon-hint {
        width: 22px;
    }


`

export const ContainerOptions = styled.div`
    z-index: 10;
    background: ${color.white};
    border-radius: 7px;
    padding: 3px;
    position: fixed;
    right: 7px;
    bottom: 60px;
    box-shadow: 0 0 0 5px rgb(245 139 30 / 5%);
    animation: slide-top;
    animation-duration: .7s;

    @keyframes slide-top {
        0% {
            transform: translateY(10px);
            opacity: 0;
        }
        100% {
            transform: translateY(0px);
        }
    }

    @media (max-width: 500px){
        right: 15px;
        bottom: 130px;
    }
`

export const ButtonOption = styled.button`
    display: flex;
    align-items: center;
    justify-content: space-between;
    min-width: 110px;
    outline: none;
    padding: 3px 6px;
    border: none;
    background: ${color.white};
    width: 100%;
    
    &:hover {
        background: ${color.grayLightest};
    }

    &:focus {
        outline: 2px auto ${color.primary}
    }
`

export const NameOption = styled.span`
    font-size: 14px;
    margin-right: 20px;
    animation: slide-left;
    animation-duration: 1.4s;

    @keyframes slide-left {
        0% {
            transform: translateX(10px);
            opacity: 0;
        }
        100% {
            transform: translateX(0px);
        }
    }
`

export const ContainerIcon = styled.div`
    outline: none;
    border-radius: 50%;
    width: 25px;
    height: 25px;
`